query agenciaEmailsSelect($where: AgenciaEmailModelFilterInput) {
    data: agenciaEmails(where: $where, order: [{email: ASC}]) {
        value: codigo
        label: email
    }
}